module.exports = __webpack_public_path__ + "assets/img/7_criteres.8382e242.svg";